export default {"src":"/_next/static/media/dimension-logo-new.de017f3d.svg","height":18,"width":124,"blurWidth":0,"blurHeight":0};